import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchDashboardSummary = createAsyncThunk('dashboard/fetchDashboardSummary', async ({ startDate = null, endDate = null } = {}, { rejectWithValue }) => {
  try {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const response = await api.get('/dashboard/summary', { params });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al obtener resumen del dashboard');
  }
});

export const fetchExpensesChart = createAsyncThunk('dashboard/fetchExpensesChart', async ({ days = 30, startDate = null, endDate = null } = {}, { rejectWithValue }) => {
  try {
    const params = startDate && endDate
      ? { start_date: startDate, end_date: endDate }
      : { days };
    const response = await api.get('/dashboard/expenses-chart', { params });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al obtener datos del gráfico');
  }
});

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    summary: null,
    chartData: [],
    loading: false,
    chartLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.summary = action.payload;
      })
      .addCase(fetchDashboardSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchExpensesChart.pending, (state) => {
        state.chartLoading = true;
      })
      .addCase(fetchExpensesChart.fulfilled, (state, action) => {
        state.chartLoading = false;
        state.chartData = action.payload;
      })
      .addCase(fetchExpensesChart.rejected, (state) => {
        state.chartLoading = false;
      });
  },
});

export const { clearError } = dashboardSlice.actions;
export default dashboardSlice.reducer;
